import type {
  SupplierPaymentInformationCreateRequestType,
  SupplierPaymentInformationCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierPaymentInformationCreate = (supplierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierPaymentInformationCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `suppliers/${supplierId}/supplier-payment-information`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierPaymentInformationCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SuppliersPaymentInformation,
          response.id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SuppliersPaymentInformation,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
